/** 检测登陆主号是否有电商工具包权限 */
import Gateway from 'src/utils/Gateway';
const cacheData = {};

/** 检测登陆主号是否有电商工具包权限 */
export function getECommerceStatus() {
    const key = 'getECommerceStatus';
    if (typeof (cacheData[key]) !== 'undefined') {
        return Promise.resolve(cacheData[key]);
    }
    const p = new Promise((resolve, reject) => {
        Gateway.get('/v1/corp/privileges').then(
            (data) => {
                if (data && data.adminPrivileges) {
                    const admP = data.adminPrivileges;
                    let hasP = false;
                    if (admP.findIndex(item => +item === 336 || +item === 337) > -1) {
                        hasP = true;
                    }

                    console.log('getECommerceStatus', hasP);

                    cacheData[key] = hasP;
                    resolve(hasP);
                } else {
                    console.log(rs.message || '请求失败');
                    resolve(false);
                }
            }
        ).catch(() => {
            console.log('请求失败');
            resolve(false);
        });
    });
    return p;
}
